const status = {
    draft: 0,
    queued: 1
};

const statusNL = {
    concept: 0,
    wachtrij: 1
};

export {
    status,
    statusNL
};
